import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import RequireAuthentication from "../component/require/RequireAuthentication"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    selectDashboardPatient,
    selectPatientsOfProfessional
} from "../redux/ProfessionalDashboard"
import notNull from "../util/notNull"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"

function RedirectMedicationView() {
    const { patient } = useParams()

    const patients = useAppSelector(selectPatientsOfProfessional)

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (patient !== undefined && notNull(patients)) {
            const found = patients.find((p) => p.id === patient)
            if (found === undefined) {
                alert(
                    "Es konnte keine Patient:in mit dieser ID gefunden werden."
                )
                navigate(
                    NavigationPaths[NAVIGATION_VIEW.PATIENT_SELECTION_VIEW].path
                )
                return
            }
            dispatch(selectDashboardPatient(found))
            navigate(
                NavigationPaths[
                    NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_MEDICATION
                ].path
            )
        }
    }, [patient, patients])

    return (
        <RequireAuthentication>
            <></>
        </RequireAuthentication>
    )
}

export default RedirectMedicationView
